import CompanyTypes from './CompanyTypes';
import StorageHelper from '../../utils/StorageHelper';
import { STORAGE_KEYS } from '../../configs/AppConfig';

const initialState = {
  companies: [],
  total: 0,
  totalPages: 0,
  queries: {
    page: 1,
    size: 10,
    search_key: ''
  },
  selected: [],
  companyDetail: {},
  companyDomain: '',
  endUserCompanyDetail: {}
};

export default function companyReducer (state = initialState, action) {
  const {
    type,
    payload
  } = action;
  let newState = { ...state };
  switch (type) {
    case CompanyTypes.GET_COMPANIES_SUCCESS:
      newState.companies = [...payload.content];
      newState.totalPages = payload.totalPages;
      newState.total = payload.totalElements;
      return newState;
    case CompanyTypes.UPDATE_COMPANIES_QUERIES:
      newState.queries.page = payload.page;
      newState.queries.size = payload.size;
      newState.queries.search_key = payload.search_key;
      return newState;
    case CompanyTypes.UPDATE_SELECTED: {
      if (payload.isSelected) {
        newState.selected = [...newState.selected, payload.selected.id];
      } else {
        newState.selected = newState.selected.filter(item => item !== payload.selected.id);
      }
      return newState;
    }
    case CompanyTypes.UPDATE_SELECTED_ALL: {
      const ids = payload.selected.map(item => item.id);
      if (payload.isSelected) {
        newState.selected = ids;
      } else {
        newState.selected = [];
      }
      return newState;
    }
    case CompanyTypes.GET_COMPANY_DETAIL_SUCCESS:
      newState.companyDetail = { ...payload };
      return newState;
    case CompanyTypes.SET_COMPANY_DOMAIN:
      newState.companyDomain = payload;
      StorageHelper.setSessionItem(STORAGE_KEYS.domain, payload);
      return newState;
    case CompanyTypes.GET_END_USER_COMPANY_DETAIL_SUCCESS:
      newState.endUserCompanyDetail = { ...payload };
      return newState;
    default:
      newState = state;
      break;
  }
  // return new state
  return newState;
}
